import OrgPermissionsAuditTable from './org-permissions-audit-table'
import DomainType from 'scoreboard/components/domain-type'
const { ORG_PERMISSIONS_AUDIT } = DomainType
import template from './org-permissions-audit.hbs'
import _ from 'lodash'
import $ from 'jquery'
import conductor from 'scoreboard/components/conductor'
import i18n from 'scoreboard/components/i18n'
import EditableButton from 'scoreboard/components/editable-button'
import OrgSelectionForm from 'scoreboard/components/org-selection-form'
import appDisplay from 'scoreboard/components/app-display'
import config from 'scoreboard/components/config'
import PermissionsAudit from '../permissions-audit'
import LoadingDots from 'scoreboard/components/loading-dots'
import { isDisplayingSendTo } from '../permissions-audit-util'
import diagnostics from '../../components/diagnostics'

const OrgPermissionsAudit = PermissionsAudit.extend(/** @lends {OrgPermissionsAudit} */{

	className: 'admin permissions-audit table-hack display-layout',

	events: _.extend({}, PermissionsAudit.prototype.events, {
		'click .set-organization': 'onClickSetOrganization',
		'click .send-to': 'onClickSendTo'
	}),

	/**
	 * The Organization Permissions Audit (#54663)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.organizationId the ID of the organization
	 *
	 * @param {$.Deferred} options.fetchPromise a promise that resolves when the
	 * data is ready to be rendered
	 */
	initialize: function(options = {}) {
		this.options = options
		this.organizationId = options.organizationId ?? conductor.id()
		this.fetchPromise = options.fetchPromise
	},

	/**
	 * @override
	 */
	domainObjectInfo () {
		return {
			domainId: this.organizationId,
			domainType: ORG_PERMISSIONS_AUDIT
		}
	},

	render: function() {
		this.$el.html(template(this.context()))
		this.renderOrgButton()
		this.fetchAndRenderResponse()
		return this
	},

	context: function() {
		let href = '/admin/groups/organizations/' + (this.organizationId ?? '')
		let link = `<a class="sp-navigate text-link" href="${href}">` +
			_.escape(i18n.get('admin.orgPermissionsAudit.banner.groupsByOrg')) +
			'</a>'
		let bannerHtml = i18n.get('admin.orgPermissionsAudit.banner', link)
		return { bannerHtml }
	},

	renderOrgButton: function() {
		this.orgButton = new EditableButton({
			el: this.$('.set-organization'),
			message: 'common.organization.choose'
		}).render()
	},

	fetch: function() {
		if (this.fetchPromise) return this.fetchPromise

		let orgId = this.organizationId
		let promise
		if (orgId && orgId != '') {
			promise = $.get(`api/admin/org-permissions-audit/${orgId}`)
		} else {
			promise = $.Deferred().resolve()
		}
		return promise
	},

	fetchAndRenderResponse: function() {
		this.$('.org-permissions-audit-table-container').empty()

		this.loadingDots = new LoadingDots({
			el: this.$('.loading-dots-container')[0]
		}).render()

		this.fetch().done(response => {
			// delete the promise so that we'll know we need to retrieve data
			// the next time an org is selected
			delete this.fetchPromise
			this.renderResponse(response)
			this.trigger('ready')
			this.loadingDots?.clear()
		})
		return this.fetchPromise
	},

	renderResponse: function(response) {
		if (_.isNil(response)) return

		this.response = response
		this.orgsById = _.keyBy(response.organizations, 'id')
		this.groupsById = _.keyBy(response.groups, 'id')

		this.renderOrgLabel()

		this.$('.send-to').toggleClass('is-not-displayed',
			!isDisplayingSendTo(this.organizationId, diagnostics.exportEnabled))
		this.orgPermissionsAuditTable?.remove()
		this.orgPermissionsAuditTable = new OrgPermissionsAuditTable({
			response,
			organizationId: this.organizationId
		})
		this.$('.org-permissions-audit-table-container').html(
			this.orgPermissionsAuditTable.el)
		this.orgPermissionsAuditTable.render()
		this.updateExportHeader({
			selectionTitle: this.orgsById?.[this.organizationId]?.label,
			pageTitle: i18n.get('admin.orgPermissionsAudit')
		})
	},

	renderOrgLabel: function(org) {
		org = org ?? this.orgsById[this.organizationId]
		this.orgButton.renderLabel(org?.label)
	},

	onClickSetOrganization: function() {
		this.orgSelectionForm?.remove()
		this.orgSelectionForm = new MyOrgSelectionForm({
			id: this.organizationId,
			projectId: this.projectId,
			enableProjects: config.enableProjects,
			allowCleanSubmission: true,
			params: { permissions: true }
		})
		appDisplay.dialog(this.orgSelectionForm)

		this.orgSelectionForm.on('selected', organization => {
			this.organizationId = organization.id
			this.updateBannerHref(organization.id)
			conductor.navigate(`admin/org-permissions-audit/${organization.id}`)
			this.renderOrgLabel(organization)
			$.when(this.fetchAndRenderResponse()).done(() => {
				this.orgSelectionForm.trigger('done') // hide the dialog
			})
		})
	},

	updateBannerHref: function(organizationId) {
		let href = `/admin/groups/organizations/${organizationId}`
		this.$('.banner [href]').attr('href', href)
	}

}, {
	display: function(organizationId) {
		let view = new OrgPermissionsAudit({ organizationId })
		appDisplay.display(view.fetch(), () => view)
	}
})

const MyOrgSelectionForm = OrgSelectionForm.extend({

	test: function() {
		if (!this.selector.selected()?.modify) {
			return i18n.get('admin.orgPermissionsAudit.noPermission')
		}
		return OrgSelectionForm.prototype.test.apply(this, arguments)
	}

})

export default OrgPermissionsAudit
export { MyOrgSelectionForm }

OrgPermissionsAudit.__filename__ = 'admin/org-permissions-audit/org-permissions-audit.js'
